import createApiClient from '../../services/apiClient';

const apiClient = createApiClient();

const applicationAPI = {
  // Get all applications with filtering
  getApplications: async (filters = {}) => {
    const params = new URLSearchParams();
    
    if (filters.jobId) params.append('jobId', filters.jobId);
    if (filters.status) params.append('status', filters.status);
    if (filters.pipelineStage) params.append('pipelineStage', filters.pipelineStage);
    if (filters.minScore) params.append('minScore', filters.minScore);
    if (filters.search) params.append('search', filters.search);
    if (filters.page) params.append('page', filters.page);
    if (filters.limit) params.append('limit', filters.limit);
    
    const response = await apiClient.get(`/applications?${params.toString()}`);
    return response.data;
  },

  // Get single application
  getApplication: async (id) => {
    const response = await apiClient.get(`/applications/${id}`);
    return response.data;
  },

  // Update scores
  updateScores: async (id, scores) => {
    const response = await apiClient.put(`/applications/${id}/scores`, scores);
    return response.data;
  },

  // Update pipeline stage (drag and drop)
  updatePipelineStage: async (id, stage, position) => {
    const response = await apiClient.put(`/applications/${id}/pipeline`, { stage, position });
    return response.data;
  },

  // Compare applications
  compareApplications: async (applicationIds) => {
    const response = await apiClient.post('/applications/compare', { applicationIds });
    return response.data;
  },

  // Get pipeline data for Kanban board
  getPipelineData: async (jobId) => {
    const params = jobId ? `?jobId=${jobId}` : '';
    const response = await apiClient.get(`/applications/pipeline${params}`);
    return response.data;
  },

  // Send email
  sendEmail: async (id, emailData) => {
    const response = await apiClient.post(`/admin/job-applications/${id}/email`, emailData);
    return response.data;
  },

  // Add note
  addNote: async (id, note) => {
    const response = await apiClient.post(`/applications/${id}/notes`, { note });
    return response.data;
  },

  // Get statistics
  getStatistics: async (jobId) => {
    const params = jobId ? `?jobId=${jobId}` : '';
    const response = await apiClient.get(`/applications/statistics${params}`);
    return response.data;
  }
};

const interviewAPI = {
  // Get all interviews (calendar view)
  getInterviews: async (filters = {}) => {
    const params = new URLSearchParams();
    
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);
    if (filters.status) params.append('status', filters.status);
    if (filters.type) params.append('type', filters.type);
    if (filters.interviewerId) params.append('interviewerId', filters.interviewerId);
    
    const response = await apiClient.get(`/interviews?${params.toString()}`);
    return response.data;
  },

  // Get my interviews
  getMyInterviews: async (upcoming = true) => {
    const response = await apiClient.get(`/interviews/my-interviews?upcoming=${upcoming}`);
    return response.data;
  },

  // Schedule interview
  scheduleInterview: async (interviewData) => {
    const response = await apiClient.post('/interviews', interviewData);
    return response.data;
  },

  // Get single interview
  getInterview: async (id) => {
    const response = await apiClient.get(`/interviews/${id}`);
    return response.data;
  },

  // Update interview
  updateInterview: async (id, updates) => {
    const response = await apiClient.put(`/interviews/${id}`, updates);
    return response.data;
  },

  // Submit feedback
  submitFeedback: async (id, feedback) => {
    const response = await apiClient.post(`/interviews/${id}/feedback`, feedback);
    return response.data;
  },

  // Cancel interview
  cancelInterview: async (id, reason) => {
    const response = await apiClient.post(`/interviews/${id}/cancel`, { reason });
    return response.data;
  }
};

export { applicationAPI, interviewAPI };
